import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { utiles } from '@utl/environment';
import { ModalErrorComponent } from '@shared/modal/modal-error/modal-error.component';
import { ModalSuccessComponent } from '@shared/modal/modal-success/modal-success.component';
import { DataMessageModel } from '@core/model/dataMessage.model';
import { environment } from 'environments/environment';

const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable({
  providedIn: 'root'
})

export class CommonService {

  private countLoading = 0;

  private loading = new BehaviorSubject(false);
  loadingService = this.loading.asObservable();

  private loginAccess = new BehaviorSubject(false);
  Access = this.loginAccess.asObservable();

  private selectedFamily = new BehaviorSubject(null);
  SelectedFamily = this.selectedFamily.asObservable();

  private productSearch = new BehaviorSubject(null);
  ProductSearch = this.productSearch.asObservable();

  private selectedFilters = new BehaviorSubject(null);
  SelectedFilters = this.selectedFilters.asObservable();

  private selectedClient = new BehaviorSubject(null);
  SelectedClient = this.selectedClient.asObservable();

  private selectedCurrency = new BehaviorSubject(null);
  SelectedCurrency = this.selectedCurrency.asObservable();

  private selectedProject = new BehaviorSubject(null);
  SelectedProject = this.selectedProject.asObservable();

  private selectedSite = new BehaviorSubject(null);
  SelectedSite = this.selectedSite.asObservable();

  private masterClientAvailable = new BehaviorSubject(null);
  MasterClientAvailable = this.masterClientAvailable.asObservable();

  private updateShoppingCart = new BehaviorSubject(false);
  UpdateShoppingCart = this.updateShoppingCart.asObservable();

  private updateShoppingCartLines = new BehaviorSubject(false);
  UpdateShoppingCartLines = this.updateShoppingCartLines.asObservable();

  private updateRedirectCart = new BehaviorSubject(false);
  UpdateRedirectCart = this.updateRedirectCart.asObservable();

  private observableFamilyQuery = new BehaviorSubject(null);
  setObservableFamilyQuery = this.observableFamilyQuery.asObservable();

  private selectedAddress = new BehaviorSubject(null);
  SelectedAddress = this.selectedAddress.asObservable();

  private updateCurrentAddress = new BehaviorSubject(false);
  UpdateCurrentAddress = this.updateCurrentAddress.asObservable();

  constructor(
    public http: HttpClient,
    private dialog: MatDialog,
    private router: Router,
  ) { }

  clearObservables() {
    this.setUpdateShoppingCart(false);
    this.setUpdateShoppingCartLines(false);
    this.setOptionAccess(false);
    this._setSelectedFamily(null);
    this._setProductSearch(null);
    this._setSelectedFilters(null);
    this._setSelectedClient(null);
    this._setSelectedCurrency(null);
    this._setSelectedProject(null);
    this._setSelectedSite(null);
    this._setMasterClientAvailable(null);
    this._setSelectedAddress(null);
    this.setUpdateRedirectCart(false);
    this.setUpdateCurrentAddress(false);
  }

  setUpdateShoppingCart(item) {
    this.updateShoppingCart.next(item);
  }

  setUpdateShoppingCartLines(item) {
    this.updateShoppingCartLines.next(item);
  }

  setUpdateRedirectCart(item) {
    this.updateRedirectCart.next(item);
  }

  setOptionAccess(item) {
    this.loginAccess.next(item);
  }

  _setSelectedFamily(item: any) {
    this.selectedFamily.next(item);
  }


  _setProductSearch(item: any) {
    this.productSearch.next(item);
  }

  _setSelectedFilters(item: any) {
    this.selectedFilters.next(item);
  }
  _setSelectedClient(item: any) {
    this.selectedClient.next(item);
  }

  _setSelectedCurrency(item: any) {
    this.selectedCurrency.next(item);
  }

  _setSelectedProject(item: any) {
    this.selectedProject.next(item);
  }
  _setSelectedSite(item: any) {
    this.selectedSite.next(item);
  }

  _setSelectedAddress(item: any) {
    this.selectedAddress.next(item);
  }

  _setMasterClientAvailable(item: any) {
    this.masterClientAvailable.next(item);
  }

  setUpdateCurrentAddress(item) {
    this.updateCurrentAddress.next(item);
  }

  _setLoading(item: any) {
    if (item) {
      this.countLoading++;
      if (this.countLoading === 1) {
        this.loading.next(item);
      }
    } else {
      this.countLoading--;
    }
    if (this.countLoading === 0) {
      this.loading.next(item);
    }
    if (this.countLoading <= 0) {
      this.countLoading = 0;
      this.loading.next(item);
    }

    // this.loading.next(item);
  }

  setFamilyQuery(item) {
    this.observableFamilyQuery.next(item);
  }

  checkIpAddress() {
    return this.http.get<{ ip: string }>('https://jsonip.com')
      .pipe(map(response => {
        return response;
      }));
  }

  onErrorModal(data: any) {
    this.countLoading = 0;
    this._setLoading(false);
    const datafailed = {
      labelTitile: 'Error',
      icon: 'cancel',
      textDescription: (data.error == null) ? '' : (data.error.text) ? data.error.text : data.error.text,
      status: 'error'
    };

    switch (data.status) {
      case 0: {
        datafailed.textDescription = 'Se ha perdido la conexión con el servidor.';
        utiles.clearAllCache();
        this.router.navigate(['']);
        const dialogRef = this.dialog.open(ModalErrorComponent, {
          data: datafailed,
          minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh'
        });
        dialogRef.afterClosed().subscribe(() => {
          dialogRef.addPanelClass('ocultar-modal');
          setTimeout(() => {
            this.dialog.closeAll();
          }, 300);
        });
        break;
      }
      case 401: {
        break;
      }
      default: {
        const dialogRef = this.dialog.open(ModalErrorComponent, {
          data: datafailed,
          minWidth: '42vw', maxWidth: '50vw', maxHeight: '50vh', minHeight: '23vh'
        });
        dialogRef.afterClosed().subscribe(() => {
          dialogRef.addPanelClass('ocultar-modal');
          setTimeout(() => {
            this.dialog.closeAll();
          }, 300);
        });
        break;
      }
    }
  }

  onSuccessModal(data: any) {
    const dialogRef = this.dialog.open(ModalSuccessComponent, {
      data,
      minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh'
    });
    dialogRef.afterClosed().subscribe(() => {
      dialogRef.addPanelClass('ocultar-modal');
      setTimeout(() => {
        this.dialog.closeAll();
      }, 300);
    });
  }

  onchangeComboHeader(type: string) {
    let data = new DataMessageModel();
    switch (type) {
      case 'project':
        data.labelTitile = 'Cambio de projecto.';
        data.textDescription = 'El carrito de compras se actualizará basado en el projecto seleccionado.';
        break;
      case 'client':
        data.labelTitile = 'Cambio de cliente.';
        data.textDescription = 'El carrito de compras se actualizará basado en el cliente seleccionado.';
        break;
      case 'site':
        data.labelTitile = 'Cambio de sucursal.';
        data.textDescription = 'El carrito de compras se actualizará basado en la sucursal seleccionado.';
        break;
      case 'currency':
        data.labelTitile = 'Cambio de moneda.';
        data.textDescription = 'El carrito de compras se actualizará basado en la moneda seleccionada.';
        break;
    }

    const dialogRef = this.dialog.open(ModalSuccessComponent, {
      data,
      minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh', disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['dashboard']);
      dialogRef.addPanelClass('ocultar-modal');
      setTimeout(() => {
        this.dialog.closeAll();
      }, 300);
    });
  }

  async getBDCurrentDate() {
    const url = environment.apiURL + 'getBDCurrentDate';
    let result = await this.http.post<Date>(url, null, httpOptions)
      .pipe(map(response => {
        return response;
      })).toPromise();
    
    return result;
  }
}
